import { Component, OnInit } from '@angular/core';
import { AuthService } from "../../services/auth.service";
import { MainserviceService } from "../.././mainservice.service";
import { Location } from "@angular/common";
import { FlashMessagesService } from 'ngx-flash-messages';
import { Router } from "@angular/router";

@Component({
  selector: 'app-addshop',
  templateUrl: './addshop.component.html',
  styleUrls: ['./addshop.component.scss']
})
export class AddshopComponent implements OnInit {

  name:string;
  link:string;
  image:any;
  logo:any;
  mall:any;
  malls:any;
  phone:number;

  constructor(
    private mainservice: MainserviceService,
    private location: Location,
    private authservice: AuthService,
    private flashmessage: FlashMessagesService,
    private router:Router
  ) { }


  ngOnInit() {
   this.mainservice.getMalls().subscribe(data => {
    this.malls = data
    console.log(this.malls)
});

  }


  onShopSubmit(){
    const shop ={
      name:this.name,
      link:this.link,
      image:this.image,
      logo:this.logo,
      mall:this.mall,
      phone:this.phone
    }
    this.authservice.addShop(shop).subscribe(data =>{
      this.flashmessage.show('Successfully Added',
      { classes:['alert-success'] , timeout: 2000});
      this.router.navigate(['/shops']);
   
 } ,error =>{
   this.flashmessage.show('Oops Something went wrong !',
   { classes:['alert-danger'] , timeout: 3000});
 })
  }
  cancel():void {
    this.location.back();
  }
   
}



// WEBPACK FOOTER //
// D:/PROJECTS/Sokousoni/winda-dashboard/dashboard-winda-mvp/src/app/shops/addshop/addshop.component.ts